import ReactGPicker from 'react-gcolor-picker'

interface AdjustColorProps {
  value: string
  onChange: (value: string) => void
}

export function AdjustColor({ value, onChange }: AdjustColorProps) {
  if (!value || !onChange) return null

  return (
    <div className="flex flex-col w-full items-center justify-center gap-1">
      <ReactGPicker
        value={value}
        onChange={(v) => onChange(v)}
        gradient
        debounceMS={10}
        solid={false}
        format="hex"
        showAlpha={false}
        showInputs
        allowAddGradientStops
        showGradientMode={false}
        showGradientAngle={false}
        showGradientResult={false}
        defaultColors={[]}
      />
    </div>
  )
}
